import { FaFacebookF, FaTwitter, FaRss, FaInstagram, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

export const socialLinks = [
   {
      id: 1,
      icon: <FaFacebookF />,
      path: "*"
   },
   {
      id: 2,
      icon: <FaTwitter />,
      path: "*"
   },
   {
      id: 3,
      icon: <FaInstagram />,
      path: "*"
   },
   {
      id: 4,
      icon: <FaRss />,
      path: "*"
   },
];

export const navLinks = [
   {
      id: 1,
      link: "Home",
      path: "/"
   },
   {
      id: 2,
      link: "About",
      path: "/about"
   },
   {
      id: 3,
      link: "Projects",
      path: "/projects"
   },
   {
      id: 4,
      link: "Blogs",
      path: "/blogs"
   },
   {
      id: 5,
      link: "Contact",
      path: "/contact"
   },
];

export const enquiryLinks = [
   {
      id: 1,
      icon: <FaPhoneAlt />,
      link: "+1 5524 5588 55",
      path: "/"
   },
   {
      id: 2,
      icon: <FaEnvelope />,
      link: "help@consultx.com",
      path: "/"
   },
];